export class User {

  token: string = '';
  name: string = '';
  id: string = '';
  platform: string = '';
  avatar: string = '';
  email: string = '';
}
